import { Property, useAppMutation } from '@alluradirect/react';

interface Values {
  resort_id: number;
  development_id?: number;
  size_category_id?: number;
  is_assisted_setup?: boolean;
  assisted_setup_url?: string;
  id: number;
}

export type PropertyCreateResponse = {
  DATA: {
    PROPERTY_ID: number;
    PROPERTY: Property;
  };
};

export const useCreatePropertyMutation = ({
  onSuccess = () => null,
}: {
  onSuccess?: (data: PropertyCreateResponse, variables: Values) => void;
} = {}) => {
  return useAppMutation<Values>({
    method: 'POST',
    url: '/RESTAUTH/user/property/create/',
    onSuccess: async (data, variables) => {
      if (onSuccess) {
        return onSuccess(data, variables);
      }
    },
  });
};
